import React from 'react';
import { useTranslation } from 'react-i18next';
import StrategySelectionModal from '../StrategySelectionModal/StrategySelectionModal';
import { PRIVILEGE_CHANGE_STRATEGIES } from '../../../constants/role.constant';

const strategies = [
  {
    value: PRIVILEGE_CHANGE_STRATEGIES.RESET,
    labelKey: 'roleChange.resetOption',
    descriptionKey: 'roleChange.resetDescription',
  },
  {
    value: PRIVILEGE_CHANGE_STRATEGIES.SYNC,
    labelKey: 'roleChange.syncOption',
    descriptionKey: 'roleChange.syncDescription',
  },
  {
    value: PRIVILEGE_CHANGE_STRATEGIES.KEEP,
    labelKey: 'roleChange.keepOption',
    descriptionKey: 'roleChange.keepDescription',
  },
];

const RoleChangeConfirmModal = ({ open, onClose, onSelectStrategy }) => {
  const { t } = useTranslation();

  return (
    <StrategySelectionModal
      open={open}
      onClose={onClose}
      onSelectStrategy={onSelectStrategy}
      title={t('roleChange.confirmTitle')}
      message={t('roleChange.confirmMessage')}
      strategies={strategies}
      id="role-change-confirm-modal"
    />
  );
};

export default RoleChangeConfirmModal;
